import { useEffect } from "react";
import {
  getCorriente,
  getTension,
  getPotActiva,
  getPotReactiva,
  getEActiva,
  getEReactiva,
  getCalculatedParameter,
} from "../redux/apiCalls/data/dataCall";

export const useDataFetching = (
  devicesSelected,
  dispatch,
  userToken,
  startDate,
  endDate,
  frec,
  setdataConsumption,
  meterSelected,
) => {
  useEffect(() => {
    if (!meterSelected?.tag) return;
    if (!startDate || !endDate) return;

    const fetchSingleMetric = async (mac) => {
      const args = [dispatch, userToken, startDate, endDate, frec, mac];

      if (meterSelected.type === "calculated") {
        try {
          const calculatedData = await getCalculatedParameter(
            ...args,
            meterSelected?.id,
          );
          return { mac, data: calculatedData, tag: meterSelected?.tag };
        } catch (error) {
          console.error(
            `Error fetching calculated parameter ${meterSelected?.tag}:`,
            error,
          );
          return { mac };
        }
      }

      switch (meterSelected?.tag?.toLowerCase()) {
        case "tension":
          return { mac, tension: await getTension(...args) };
        case "corriente":
          return { mac, corriente: await getCorriente(...args) };
        case "potencia activa":
          return { mac, potActiva: await getPotActiva(...args) };
        case "potencia reactiva":
          return { mac, potReactiva: await getPotReactiva(...args) };
        case "energia activa":
        case "eactiva":
          return { mac, eActiva: await getEActiva(...args) };
        case "energia reactiva":
        case "energia inductiva":
        case "ereactiva":
          return { mac, eReactiva: await getEReactiva(...args) };
        default:
          return { mac };
      }
    };

    const fetchAllDevicesData = async () => {
      try {
        const results = await Promise.all(
          devicesSelected.map((device) => fetchSingleMetric(device.mac)),
        );
        setdataConsumption(results);
      } catch (error) {
        console.error("Error fetching device data:", error);
      }
    };

    fetchAllDevicesData();
  }, [startDate, endDate, frec, devicesSelected, meterSelected]);
};
